





































































import { Component, Provide, Vue } from 'vue-property-decorator';
import { EventBus } from "@/event-bus";
import DonorService from "../../services/donor.service.js";
import axios from 'axios';

@Component({})
export default class ImportModal extends Vue {
  @Provide()
  isImportProcessed: boolean = false;
  isImportFail: boolean = false;
  file: any = null;
  isFileCheck: boolean = true;

  showModal() {
    this.$root.$emit('bv::show::modal', 'import-g-modal');
  }

  hideModal() {
    this.isImportProcessed = false;
    this.isImportFail = false;
    this.$root.$emit('bv::hide::modal', 'import-g-modal');
    this.$emit('closeModal');
  }

  importGCodes(event: Event) {    
    let formData = new FormData();
    formData.append("file", this.file);
    //@ts-ignore
    formData.append("isTemporary", true);

    this.isImportProcessed = true;
    this.isImportFail = false;
    axios.post("/GroupGCodes/import", formData, { headers: { "Content-Type": "multipart/form-data" } })
        .then((response) => { 
          const div = document.createElement("div");
              if (response.data) {
                  div.innerHTML = response.data.htmlMessage;
              }
              else {
                  div.innerHTML = this.$t('Ошибка соединения') + '';
              }
              //@ts-ignore
              this.$swal({
                  title: this.$t('Результаты проверки'),
                  content: div,
                  className: 'swal-donors-import-check',
                  icon: "success",
                  buttons: {
                      ok: {
                          className: "btn-primary",
                          text: this.$t('Выполнить импорт'),
                          value: "ok"
                      },
                      copy: {
                          className: "btn-secondary",
                          text: this.$t('Скопировать текст'),
                          value: "copy"
                      },
                      cancel: "Отказаться"
                  }
              }).then((value: any) => {
                  switch (value) {
                      case "ok":
                          this.$root.$emit('bv::hide::modal', 'import-g-modal');
                          this.realImportGCodes();
                          break;
                      case "cancel":
                          this.isImportProcessed = false;
                          break;
                      case "copy":
                        //@ts-ignore                         
                        this.$copyText(response.data.message)
                            .then(() => {
                              //@ts-ignore
                                this.$swal("", this.$t('Текст скопирован'), "success");
                            }, (e: any) => {
                                  //@ts-ignore
                                  this.$swal("", this.$t('Ошибка при копировании текста'), "warning");
                                });
                        break;
                  }
              });
              this.isImportProcessed = false;
        })
        .catch((error) => {
          this.isImportProcessed = false;
          if(error && error.data)
          {
            EventBus.$emit('error', { msg: error.data.message });
          }          
        })
        .finally(() => {
          //@ts-ignore
          this.$refs['file-input'].reset();
          this.file = null;
        });
  }

  realImportGCodes() {
    let formData = new FormData();
    //@ts-ignore
    formData.append("isTemporary", false);
    EventBus.$emit('showThrobber');
    axios.post("/GroupGCodes/import", formData)
         .then((response) => { 
            this.hideModal();
            this.isImportProcessed = false;
            const div = document.createElement("div");
                if (response.data) {
                    div.innerHTML = response.data.htmlMessage;
                }
                else {
                    div.innerHTML = this.$t('Ошибка соединения') + '';
                }
                //@ts-ignore
                this.$swal({
                    title: this.$t('Успешный импорт'),
                    content: div,
                    icon: "success"
                }).then(() => {
                    this.isImportProcessed = false;
                    window.location.reload();
                });
         })
         .catch((error) => {
            const div = document.createElement("div");
                div.innerHTML = error.data.htmlMessage;
                //@ts-ignore
                this.$swal({
                    title: this.$t('Предупреждение'),
                    content: div,
                    icon: "warning",
                    buttons: {
                        ok: "Ok",
                        copy: {
                            text: this.$t('Скопировать')
                        }
                    }
                }).then((value: any) => {
                    switch (value) {
                        case "ok":
                            this.isImportProcessed = false;
                            break;
                        case "copy":
                            this.isImportProcessed = false;
                            //@ts-ignore
                            this.$copyText(error.data.message)
                                .then(function () {
                                  //@ts-ignore
                                    this.$swal("", this.$t('Текст скопирован'), "success");
                                },
                                    function () {
                                      //@ts-ignore
                                        this.$swal("", this.$t('Ошибка при копировании текста'), "warning");
                                    });
                            break;
                    }
                });
         })
         .finally(() => {EventBus.$emit('hideThrobber');});
  }
}
